import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import outpatient from './modules/outpatient'
import inpatient from './modules/inpatient'
import tenant from './modules/tenant'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    user,
    outpatient,
    inpatient,
    tenant
  }
})
